import { currentLanguage } from '../i18n'
import * as no from './leasingTooltipContent'
import * as en from './leasingTooltipContent.en'

// The leasing tooltips by language (#714). leasingTooltipContent.ts is
// QA-frozen and must stay byte-identical, so the English text lives in a
// sibling file and every caller imports from here. The language is read at
// call time, i.e. during render, so a switch shows on the next render.
const pick = () => (currentLanguage() === 'en' ? en : no)

type Row = Parameters<typeof no.getListeprisTooltip>[0]

export const getListeprisTooltip = (result: Row): string => pick().getListeprisTooltip(result)
export const getInitialTotalTooltip = (result: Row): string => pick().getInitialTotalTooltip(result)
export const getLeasePriceTooltip = (result: Row): string => pick().getLeasePriceTooltip(result)
export const getLeasingpris1Tooltip = (result: Row): string => pick().getLeasingpris1Tooltip(result)
export const getTotalpris1Tooltip = (result: Row): string => pick().getTotalpris1Tooltip(result)
export const getMetallicTooltip = (result: Row): string => pick().getMetallicTooltip(result)
export const getServiceTooltip = (result: Row): string => pick().getServiceTooltip(result)
export const getTowingHitchTooltip = (result: Row): string => pick().getTowingHitchTooltip(result)
export const getOppCostTooltip = (result: Row): string => pick().getOppCostTooltip(result)
export const getMileageTooltip = (result: Row): string => pick().getMileageTooltip(result)
export const getHighMileageTooltip = (result: Row): string => pick().getHighMileageTooltip(result)
export const getManualCorrectionTooltip = (result: Row): string => pick().getManualCorrectionTooltip(result)
export const getAdjustmentsTooltip = (result: Parameters<typeof no.getAdjustmentsTooltip>[0]): string =>
  pick().getAdjustmentsTooltip(result)
export const getLeasingpris2Tooltip = (result: Row): string => pick().getLeasingpris2Tooltip(result)
export const getTotalpris2Tooltip = (result: Row): string => pick().getTotalpris2Tooltip(result)
export const getMonthlyLeaseFactorTooltip = (result: Row): string => pick().getMonthlyLeaseFactorTooltip(result)
